<template>
  <xm-page>
    <div class="order-detail">
      <div class="header">
        <img src="https://image.xiaomaiketang.com/xm/Jecx5k8XKs.png" class="image" alt="">
        <span class="status" v-if="orderDetail.state == 'PAY_WAITING' || orderDetail.state == 'PAY_FAILED'">待支付</span>
        <span class="status success" v-if="orderDetail.state == 'PAY_SUCCESS'">已支付</span>
        <span class="status" v-if="orderDetail.state == 'USER_CANCEL' || orderDetail.state == 'PAY_TIMEOUT'">已取消</span>
        <span class="tip" v-if="orderDetail.state == 'PAY_WAITING' || orderDetail.state == 'PAY_FAILED'">{{countDown}}内付款，超时订单将自动取消</span>
        <span class="tip" v-if="orderDetail.state == 'USER_CANCEL' || orderDetail.state == 'PAY_TIMEOUT'">超时未付款，订单自动取消</span>
      </div>

      <div class="student">
        <img class="avatar" :src="orderDetail.receiverAvatarUrl || 'https://image.xiaomaiketang.com/xm/fwxmf84s8n.png'" alt="">
        <span class="name">{{orderDetail.receiverName}}</span>
      </div>

      <div class="info">
        <div class="inst">
          <span class="icon iconfont">&#xe60c;</span>
          <span class="word">{{(orderDetail.orderDetails || [{}])[0].instName}}</span>
        </div>
        <div class="box">
          <img class="image" :src="(orderDetail.orderDetails || [{}])[0].coverUrl || 'https://image.xiaomaiketang.com/xm/kNYEN5Qiw6.png'" alt="">
          <div class="detail">
            <span class="name">{{(orderDetail.orderDetails || [{}])[0].specName}}</span>
            <div class="unit">
              <span class="number">
                {{((orderDetail.orderDetails || [{}])[0].commoditySpecs || {}).containQuantity}}
                {{((orderDetail.orderDetails || [{}])[0].commoditySpecs || {}).measurementUnits}}
              </span>
              <span class="price">¥{{moneyFormatGroup((orderDetail.orderDetails || [{}])[0].tradeAmount, 2)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="order">
        <span class="title">订单信息</span>
        <span class="text">订单编号：{{orderDetail.id}}</span>
        <span class="text">创建时间：{{createDate}}</span>
        <span v-if="orderDetail.state == 'PAY_SUCCESS'" class="text">支付时间：{{payDate}}</span>
      </div>

      <div class="description">
        <span class="remark">备注</span>
        <div class="text">{{orderDetail.memo}}</div>
      </div>
      
      <div class="footer" v-if="orderDetail.state == 'PAY_WAITING' || orderDetail.state == 'PAY_FAILED'">
        <span class="text">合计：¥{{moneyFormatGroup((orderDetail.orderDetails || [{}])[0].tradeAmount, 2)}}</span>
        <div class="submit" @click="submit">支付</div>
      </div>
    </div>
  </xm-page>
</template>
<script>
import User from "@/core/user";
import { moneyFormatGroup } from '../../core/filters';
import Platform from "@/core/platform";

export default {
  data() {
    return {
      studentInfo: {},
      orderDetail: {},
      countDown: '',
      createDate: '',
      payDate: '',
      moneyFormatGroup,
    };
  },

  methods: {
    fetchOrderDetail() {
      const data = {
        orderId: window.getParameterByName('orderId'),
        userId: User.uid(),
      };
      axios.Customer('public/customerOrder/getDetail', data).then((res) => {
        if (res.success) {
          this.orderDetail = res.result;
          this.countDown = moment(moment(res.result.created).add(30, 'm').valueOf() - moment().valueOf()).format('mm分ss秒');
          this.createDate = moment(res.result.created).format('YYYY-MM-DD HH:mm');
          if (res.result.state == 'PAY_SUCCESS') {
            this.payDate = moment(res.result.payDate).format('YYYY-MM-DD HH:mm');
          }
        }
      });
    },

    submit() {
      const data = {
        orderId: window.getParameterByName('orderId'),
        userId: User.uid(),
        openId: User.openId(),
      };
      axios.Customer('public/customerOrder/initiatePayment', data).then((res) => {
        if (!res.success) {
          window.wheatToast("获取支付参数失败!");
          return;
        }
        if (Platform.isWeiXin()) {
          this.doWechatPay(res.result);
        } else if (Platform.isAlipay()) {
          this.doAlipay(res.result);
        }
      });
    },
    weixinJSBridgeInvoke(sign) {
      window.WeixinJSBridge.invoke("getBrandWCPayRequest", sign, res => {
        alert("支付失败，请重试", JSON.stringify(res));
      });
    },

    doWechatPay(data) {
      const getBrandWCPayRequest = {
        appId: data.appId, //公众号名称，由商户传入
        timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
        nonceStr: data.nonceStr, //随机串
        package: "prepay_id=" + data.prepayId,
        signType: data.signType || "MD5", //微信签名方式:
        paySign: data.paySign //微信签名
      };
      if (window.WeixinJSBridge) {
        this.weixinJSBridgeInvoke(getBrandWCPayRequest);
      } else if (document.addEventListener) {
        document.addEventListener(
          "WeixinJSBridgeReady",
          () => {
            this.weixinJSBridgeInvoke(getBrandWCPayRequest);
          },
          false
        );
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", () => {
          this.weixinJSBridgeInvoke(getBrandWCPayRequest);
        });
        document.attachEvent("onWeixinJSBridgeReady", () => {
          this.weixinJSBridgeInvoke(getBrandWCPayRequest);
        });
      }
    },

    doAlipay(data) {
      AlipayJSBridge.call(
        "tradePay",
        {
          tradeNO: data.prepayId
        },
        result => {
          alert("支付失败请重试");
        }
      );
    },
  },

  mounted() {
    this.studentInfo = User.getUserInfo() || {};
    this.fetchOrderDetail();
  },
}
</script>

<style lang="less">
  .order-detail {
    padding-bottom: 0.88rem;
    .header {
      position: relative;
      height: 1.6rem;
      width: 100%;
      background:linear-gradient(270deg,rgba(70,184,255,1) 0%,rgba(22,137,255,1) 100%);
      margin-bottom: 0.2rem;
      .status {
        position: absolute;
        top: 0.32rem;
        left: 0.46rem;
        color: #fff;
        font-size: 0.34rem;
        line-height: 0.48rem;
        &.success {
          top: 0.56rem;
        }
      }
      .tip {
        position: absolute;
        top: 0.92rem;
        left: 0.46rem;
        color: #fff;
        font-size: 0.26rem;
        line-height: 0.36rem;
      }
      .image {
        top: 0.12rem;
        right: 0;
        width: 2.26rem;
        height: 1.24rem;
        position: absolute;
      }
    }
    .student {
      background: #fff;
      height: 1.2rem;
      padding: 0.2rem 0.32rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;
      .avatar {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        margin-right: 0.24rem;
      }
      .name {
        font-size: 0.3rem;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .info {
      background: #fff;
      margin-bottom: 0.2rem;
      .inst {
        display: flex;
        padding: 0 0.32rem;
        align-items: center;
        height: 0.8rem;
        .icon {
          color: #999;
          font-size: 0.3rem;
          margin-right: 0.1rem;
        }
        .word {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #999;
          font-size: 0.26rem;
          flex-shrink: 0;
        }
      }
      .box {
        height: 2rem;
        padding: 0.2rem 0.3rem;
        display: flex;
        .image {
          width: 1.6rem;
          height: 1.6rem;
          margin-right: 0.3rem;
        }
        .detail {
          height: 1.6rem;
          width: ~'calc(100% - 1.9rem)';
          position: relative;
          .name {
            display: block;
            font-size: 0.3rem;
            color: #333;
            line-height: 0.42rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
          }
          .unit {
            position: absolute;
            width: 100%;
            bottom: 0;
            display: flex;
            justify-content: space-between;
            font-size: 0.3rem;
            line-height: 0.42rem;
            .number {
              color: #999;
            }
            .price {
              color: #FF8534;
            }
          }
        }
      }
    }
    .order {
      padding: 0.2rem 0.32rem 0.08rem;
      text-align: left;
      background: #fff;
      margin-bottom: 0.2rem;
      .title {
        font-size: 0.3rem;
        color: #333;
        font-weight: 500;
        display: block;
        margin-bottom: 0.12rem;
        line-height: 0.42rem;
      }
      .text {
        font-size: 0.26rem;
        color: #999;
        margin-bottom: 0.12rem;
        display: block;
        line-height: 0.36rem;
      }
    }
    .description {
      background: #fff;
      padding: 0.24rem 0.32rem;
      text-align: left;
      min-height: 2.4rem;
      .remark {
        display: block;
        text-align: left;
        color: #333;
        line-height: 0.42rem;
        font-size: 0.3rem;
        margin-bottom: 0.08rem;
      }
      .text {
        white-space: pre-wrap;
        font-size: 0.3rem;
        color: #666;
        line-height: 0.42rem;
      }
    }
    .footer {
      position: fixed;
      display: flex;
      justify-content: space-between;
      bottom: 0;
      left: 0;
      height: 0.88rem;
      width: 100%;
      background: #fff;
      .text {
        border-top: 1px solid #eee;
        padding: 0.22rem 0.32rem;
        font-size: 0.3rem;
        color: #666;
        line-height: 0.42rem;
        height: 0.88rem;
        box-sizing: border-box;
        width: ~'calc(100% - 2.4rem)';
        text-align: left;
      }
      .submit {
        width: 2.4rem;
        height: 0.88rem;
        background: #3296FA;
        color: #fff;
        text-align: center;
        line-height: 0.88rem;
        font-size: 0.3rem;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/module/mall/OrderDetail.vue